import React, { useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const counters = entry.target.querySelectorAll('.feature-num');
            counters.forEach((counter) => {
              const target = parseInt(counter.textContent);
              animateCounter(counter, target);
            });
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const animateCounter = (element, target) => {
    let current = 0;
    const increment = target / 50;
    const duration = 1500;
    const stepTime = duration / 50;

    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        element.textContent = target;
        clearInterval(timer);
      } else {
        element.textContent = Math.floor(current);
      }
    }, stepTime);
  };

  return (
    <section id="about" className="about" ref={sectionRef}>
      <div className="about-bg">
        <img src="https://images.unsplash.com/photo-1585032226651-759b368d7246?w=1920&q=80" alt="面道故事" />
      </div>
      <div className="about-container">
        <div className="about-image">
          <div className="image-wrapper">
            <img
              src="https://images.unsplash.com/photo-1562967960-f55495a8899b?w=600&q=80"
              alt="面道传承"
              className="about-img"
            />
            <div className="seal">老字号</div>
            <div className="years">1928</div>
          </div>
        </div>
        <div className="about-content">
          <div className="about-badge">
            <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=100&q=80" alt="手工技艺" />
          </div>
          <span className="section-label">品牌故事</span>
          <h2>三代传承，一碗好面</h2>
          <div className="story-text">
            <p>1928年，第一代创始人张德顺在北平胡同里开了一间小小面摊。他常说："做面如做人，要实在。"</p>
            <p>从和面、醒面到拉面、煮面，每一道工序都马虎不得。这一坚持，就是近百年。</p>
            <p>如今，"面道"已传承至第三代。我们在保留传统手艺的同时，也不断精进配方，只为那一口记忆中的味道。</p>
          </div>
          <div className="about-features">
            <div className="about-feature">
              <span className="feature-num">98</span>
              <span className="feature-unit">年</span>
              <span className="feature-label">传承历程</span>
            </div>
            <div className="about-feature">
              <span className="feature-num">24</span>
              <span className="feature-unit">遍</span>
              <span className="feature-label">拉伸工艺</span>
            </div>
            <div className="about-feature">
              <span className="feature-num">12</span>
              <span className="feature-unit">小时</span>
              <span className="feature-label">骨汤熬制</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
